import { Form } from "antd";
import type { FormItemProps } from "antd";
import type { FC, PropsWithChildren } from "react";

export const FormItem: FC<PropsWithChildren<FormItemProps>> = ({
  name,
  label,
  rules,
  children,
  ...props
}) => {
  return (
    <Form.Item name={name} label={label} rules={rules} {...props}>
      {children}
    </Form.Item>
  );
};
